import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheGrandEntrance from "./sections/TheGrandEntrance";
import MagicalExperiences from "./sections/MagicalExperiences";
import SignatureMagicalExperiences from "./sections/SignatureMagicalExperiences";
import MeetThePartyLady from "./sections/MeetThePartyLady";
import SignatureMagicMoments from "./sections/SignatureMagicMoments";
import TheStressFreeSpell from "./sections/TheStressFreeSpell";
import KindWordsStardust from "./sections/KindWordsStardust";
import WhereTheMagicTravels from "./sections/WhereTheMagicTravels";
import SummonTheMagic from "./sections/SummonTheMagic";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheGrandEntrance />
      <MagicalExperiences />
      <SignatureMagicalExperiences />
      <MeetThePartyLady />
      <SignatureMagicMoments />
      <TheStressFreeSpell />
      <KindWordsStardust />
      <WhereTheMagicTravels />
      <SummonTheMagic />
      <Footer />
    </div>;
}